import React from 'react'
import styled, { css } from 'styled-components'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

const leftStyle = css`
  background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(136, 136, 136, 0.5));
  left: 0;
`

const rightStyle = css`
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(136, 136, 136, 0.5));
  right: 0;
`

const disabledStyle = css`
  opacity: 0;
  pointer-events: none;
`

type ContainerProps = { $right?: boolean; $disabled?: boolean }

export const Container = styled.div<ContainerProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.9);
  z-index: 1;
  cursor: pointer;

  .MuiSvgIcon-root {
    font-size: 36px;
  }

  ${(props) => (props.$right ? rightStyle : leftStyle)}
  ${(props) => props.$disabled && disabledStyle}
`

const withArrowContainer = (Component, right) => (props) => {
  const { onClick, className } = props
  const disabled = className.includes('slick-disabled')

  return (
    <Container $right={right} onClick={onClick} $disabled={disabled}>
      <Component />
    </Container>
  )
}

export const PrevArrow = withArrowContainer(ChevronLeftIcon, false)
export const NextArrow = withArrowContainer(ChevronRightIcon, true)
